import { Fragment, useEffect, useState } from "react";
import Header from "./Header/Header";
import SideBarNav from "./SideBarNav/SideBarNav";
import MainContent from "./MainContent/MainContent";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../store/actions";
import StoreStateModel from "../Utils/Models/store";
import { useMediaQuery, useTheme } from "@mui/material";

interface Props {
  children: any;
  sideBarNavList: any;
}
function Layout(props: Props) {
  const openSideBarNav = useSelector(
    (state: StoreStateModel) => state.layout.isOpenSideBar,
    shallowEqual
  );
  const prefersDarkMode = useSelector(
    (state: StoreStateModel) => state.layout.prefersDarkMode,
    shallowEqual
  );
  const hasPermissionShippingWrite = useSelector(
    (state: StoreStateModel) => state.auth.hasPermissionShippingWrite,
    shallowEqual
  );
  const hasPermissionSupportOperatorWrite = useSelector(
    (state: StoreStateModel) => state.auth.hasPermissionSupportOperatorWrite,
    shallowEqual
  );

  const dispatch = useDispatch();

  const [firstTime, setFirstTime] = useState(true);
  //this is to close the sidebar when there is a transition to mobile screen
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  useEffect(() => {
    if (matches == false && firstTime === false) {
      dispatch(actions.changeSideBar(!openSideBarNav));
    }
  }, [matches]);
  ////
  useEffect(() => {
    setFirstTime(false);
  }, []);
  return (
    <Fragment>
      <div>
        <Header
          handleOpenSideBarNavClicked={() => {
            dispatch(actions.changeSideBar(!openSideBarNav));
          }}
          changeTheme={() => dispatch(actions.changeTheme())}
          prefersDarkMode={prefersDarkMode}
          hasPermissionSupportOperatorWrite={hasPermissionSupportOperatorWrite}
          hasPermissionShippingWrite={hasPermissionShippingWrite}
        />

        <SideBarNav
          handleOpenSideBarNavClicked={() => {
            dispatch(actions.changeSideBar(!openSideBarNav));
          }}
          openSideBarNav={openSideBarNav}
          handleDrawerToggle={() => dispatch(actions.changeSideBar(false))}
        >
          {props.sideBarNavList}
        </SideBarNav>

        <MainContent openSideBarNav={openSideBarNav}>{props.children}</MainContent>
      </div>
    </Fragment>
  );
}

export default Layout;
